import { LitElement, html, css } from 'lit'
import {customElement, property} from 'lit/decorators.js'
import { v4 as uuid } from 'uuid'

import '@shoelace-style/shoelace/dist/themes/light.css'
import '@shoelace-style/shoelace/dist/components/button/button.js'
import '@shoelace-style/shoelace/dist/components/card/card.js'
import '@shoelace-style/shoelace/dist/components/input/input.js'
import '@shoelace-style/shoelace/dist/utilities/form.js'

@customElement('vx-iamie-app')
class TIAmieAPP extends LitElement {
    static styles = css`
    :host {
        display: block;
        height: 100vh;
        margin: 0;
    }

    .header {
        margin: 0 0 2rem 0;
    }

    .main {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }

    sl-card {
        width: 30vw;
        padding: 2rem;
        border-radius: 10px;
    }

    vxc-docs-list {
        height: 100%;
    }


    sl-button {
        float: right;
    }

    @media (max-width: 1024px) {
        sl-card {
            width: 50vw;
        }
    }

    @media (max-width: 767px) {
        sl-card {
            width: 100vw;
        }
    }    

    form {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .title {
        text-align: center;
        margin: 0px;
        padding: 0px;
    }
    `

    @property({ type: String, attribute: 'logo-src'         }) logoSrc = ''
    @property({ type: String, attribute: 'logo-alt'         }) logoAlt = 'Logo'
    @property({ type: String, attribute: 'brand'            }) title   = 'Brand'
    @property({ type: Object, attribute: false              }) userData: Record<string,any>|null = null
    @property({ type: String                                }) host: string = ''
    @property({ type: String                                }) app: string = ''
    @property({ type: String, attribute: 'data-app-var-name'}) varName: string = 'voxy-ai-chat-data'

    constructor() {
        super();
    }

    updated(changedProperties: Map<string | number | symbol, unknown>): void {
        super.updated(changedProperties)
        if(changedProperties.has('varName')) {
            console.log('varname was set to', this.varName)
            // Check if user exists in local storage
            try { 
                var userData = JSON.parse(localStorage.getItem(this.varName)||'') 
                if(userData)    this.userData = {user: userData}
            }
            catch(e) {}
        }
    }

    private register(event: CustomEvent) {
        console.log('register user', event.detail)
        event.preventDefault()
        const formData = new FormData(event.target as HTMLFormElement)
        const userData = {
            uid: uuid(),
            name: formData.get('name'),
            job: formData.get('job')
        }
        console.log('user data', userData)
        localStorage.setItem(this.varName, JSON.stringify(userData))
        this.userData = {user: userData}
    }

    private handleMenuItemClick(event: CustomEvent) {
        const btnId = event.detail?.id
        switch(btnId) {
            case 'disconnect':
                console.log('disconnecting...')
                localStorage.removeItem(this.varName)
                this.userData = null
                break
        }
    }

    render() {
        const user = this.userData?.user 
        console.log('render', user)
        return html`
            ${ user?.uid 
              ? html`
            <div class="header">
                <vxc-navbar
                    logo-src=${this.logoSrc}
                    brand=${this.title}
                    menu-items=${JSON.stringify([{ "id": "disconnect", "label": "déconnexion", "active": false }])}
                    @menu-item-click=${this.handleMenuItemClick}
                ></vxc-navbar>
            </div>
            <div class="main">
                <vxc-docs-list
                    app=${this.app}
                    host=${this.host}
                ></vxc-docs-list>
                <vxc-chatbot
                    app=${this.app}
                    host=${this.host}
                    data=${JSON.stringify(this.userData||{})}
                ></vxc-chatbot>
            </div>
              ` 
              : html`
            <div class="main">
                <sl-card>
                    <h2 slot="header" class="title">Inscription</h2>
                    <form @submit=${this.register}>
                        <sl-input name="name" placeholder="votre prénom et nom" required></sl-input>
                        <sl-input name="job" placeholder="votre fonction ou métier" required></sl-input>
                        <sl-button type="submit" variant="primary">Commencez à utiliser !</sl-button>
                    </form>
                </sl-card>
            </div>
              `}
        `;
    }
}


declare global {
  interface HTMLElementTagNameMap {
    'vx-iamie-app': TIAmieAPP;
  }
}

